module.exports = __webpack_public_path__ + "img/multi-section.4e0aa6c3.png";